import { MessageDescriptor } from 'react-intl';

export function isMessageDescriptor(arg: any): arg is MessageDescriptor {
    return arg && arg.id !== undefined;
}